module.exports = __webpack_public_path__ + "img/51-3.c12155da.png";